var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkexpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 309,
    viewBox: "0 0 613 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1249_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8861 285.833C-17.2139 256.143 12.8461 176.71 58.1791 128.133C113.305 69.075 189.298 19.396 336.198 36.2899C457.498 50.247 532.804 111.447 558.42 142.967C599.153 193.067 628.581 263.758 604.049 292.994C562.881 342.068 392.79 258.57 300.529 256.868C208.268 255.166 73.6431 352.022 10.8861 285.833Z",
    fill: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.776 238.4H126.595L59.25 18.167C58.6055 16.064 58.4637 13.839 58.8361 11.6712C59.2086 9.50333 60.0848 7.45322 61.3942 5.68586C62.7036 3.91851 64.4098 2.48328 66.3752 1.49571C68.3406 0.508149 70.5105 -0.00416008 72.71 2.54414e-05H363.476C366.486 -0.000236797 369.417 0.96616 371.837 2.7569C374.257 4.54764 376.037 7.06807 376.917 9.94703L446.776 238.4Z",
    fill: "#EB9481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.341 212.182H164.637C161.6 212.181 158.642 211.206 156.2 209.4C153.758 207.594 151.96 205.051 151.07 202.147L100.072 35.364C99.7474 34.3059 99.6755 33.1863 99.8623 32.0953C100.049 31.0043 100.489 29.9724 101.148 29.0826C101.806 28.1928 102.664 27.47 103.653 26.9723C104.642 26.4746 105.733 26.2159 106.84 26.217H336.54C339.578 26.2176 342.535 27.1927 344.977 28.9991C347.419 30.8054 349.217 33.3477 350.107 36.252L401.107 203.035C401.432 204.093 401.504 205.213 401.317 206.304C401.13 207.395 400.69 208.427 400.031 209.316C399.373 210.206 398.515 210.929 397.526 211.427C396.538 211.924 395.446 212.183 394.339 212.182H394.341Z",
    fill: "#1C3177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.595 238.399H556.668C558.105 238.399 559.528 238.682 560.855 239.233C562.182 239.783 563.388 240.589 564.404 241.605C565.42 242.621 566.225 243.827 566.775 245.155C567.325 246.482 567.607 247.905 567.607 249.342V263.96C567.607 266.861 566.454 269.643 564.403 271.694C562.351 273.746 559.569 274.898 556.668 274.899H137.534C134.633 274.898 131.851 273.746 129.8 271.694C127.748 269.643 126.596 266.861 126.595 263.96V238.399Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.011 127.228L205.169 98.0281",
    stroke: "#99ADF9",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.344 127.228L171.953 98.0281",
    stroke: "#99ADF9",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.18 127.228L334.338 98.0281",
    stroke: "#99ADF9",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.516 127.228L301.116 98.0281",
    stroke: "#99ADF9",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.526 145.69C243.526 145.69 264.031 134.381 284.858 145.69",
    stroke: "#99ADF9",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.464 111.223C465.092 111.217 462.794 110.401 460.95 108.91C459.106 107.418 457.827 105.341 457.325 103.023C455.397 94.3301 454.174 87.6921 455.876 81.4831C457.918 74.1201 463.306 69.8091 469.109 65.6831C473.022 62.9091 475.738 58.6991 476.041 54.9671C476.13 53.7376 475.928 52.5045 475.452 51.3676C474.975 50.2307 474.238 49.222 473.299 48.4231C467.212 42.5161 457.356 51.7071 456.915 52.1041C456.915 52.1041 448.635 59.1141 442.484 51.7641C436.333 44.4141 442.484 37.1271 442.484 37.1271C446.452 33.4423 451.017 30.4582 455.984 28.3021C467.823 23.2541 479.103 25.1451 487.751 33.4971C490.881 36.4293 493.313 40.0253 494.871 44.021C496.428 48.0167 497.071 52.3105 496.751 56.5871C495.989 66.5341 490.151 76.2991 481.117 82.6871C476.876 85.6941 476.076 86.7591 475.88 87.1001C475.395 88.6381 476.995 95.8431 477.6 98.5601C477.935 100.079 477.926 101.654 477.573 103.169C477.22 104.684 476.532 106.101 475.56 107.315C474.588 108.53 473.356 109.511 471.955 110.187C470.554 110.863 469.02 111.217 467.464 111.223Z",
    fill: "#FEC272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.474 147.292C479.132 147.292 484.529 141.893 484.529 135.233C484.529 128.573 479.132 123.174 472.474 123.174C465.816 123.174 460.419 128.573 460.419 135.233C460.419 141.893 465.816 147.292 472.474 147.292Z",
    fill: "#FEC272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1249_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 612.998,
    height: 308.999,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkexpire);
export default __webpack_public_path__ + "static/media/linkexpire.7f0ffe40cf067b188e41d809884c25cf.svg";
export { ForwardRef as ReactComponent };